/*
 * Use enum, which is compiled into an object at runtime, so we can iterate
 * over its keys.
 */
export enum EFlags {
  // Show the Pixl Group Builder in the Predicates UI
  aiGroupBuilder = 'aiGroupBuilder',
  bypassMX = 'bypassMX',
  // Show the cookie-consent banner on published landing pages (display only; enforcement is server-side)
  consentBannerEnabled = 'consentBannerEnabled',
  creditCardConvenienceFeeAccepted = 'creditCardConvenienceFeeAccepted',
  // CSM's are now called Account Managers
  csmManager = 'csmManager',
  enforceOnboarding = 'enforceOnboarding',
  entriDomainAuth = 'entriDomainAuth',
  hasBlackbaudRaisersEdge = 'hasBlackbaudRaisersEdge',
  hasGoogleAds = 'hasGoogleAds',
  hasImis = 'hasImis',
  hasMultiConversions = 'hasMultiConversions',
  locales = 'locales',
  mailrail = 'mailrail',
  metaIntegrationOutage = 'metaIntegrationOutage',
  minBudget = 'minBudget',
  monetization = 'monetization',
  noMaxBudget = 'noMaxBudget',
  noMinAudience = 'noMinAudience',
  overridePackageImplementationsAccess = 'overridePackageImplementationsAccess',
  pinpoint = 'pinpoint',
  pinpointSendAllEmails = 'pinpointSendAllEmails',
  showAccountReports = 'showAccountReports',
  showAPIKeysV2 = 'showAPIKeysV2',
  // Prevent limiting audience categories to industry, demographic or in-market
  showAllAffinityAudiences = 'showAllAffinityAudiences',
  showCampaignRecommendations = 'showCampaignRecommendations',
  showConversionsSettingsV2 = 'showConversionsSettingsV2',
  showDripBulkEnroll = 'showDripBulkEnroll',
  showDripCampaigns = 'showDripCampaigns',
  showCommandPalette = 'showCommandPalette',
  showEmailActivityExport = 'showEmailActivityExport',
  showForms = 'showForms',
  showFundraise = 'showFundraise',
  showFundraiseCRM = 'showFundraiseCRM',
  showGrowthCredits = 'showGrowthCredits',
  showImportRunDetails = 'showImportRunDetails',
  showNewPrimaryNav = 'showNewPrimaryNav',
  showOnboarding = 'showOnboarding',
  showProResources = 'showProResources',
  showUsageMetrics = 'showUsageMetrics',
  showUsersAndRolesV2 = 'showUsersAndRolesV2',
  useContactLimits = 'useContactLimits',
  useEmailLimits = 'useEmailLimits',
  zapier = 'zapier',
  showGoalsV2 = 'showGoalsV2',
}

export type TFlags = keyof typeof EFlags;

export type TFlagsRecord = Partial<Record<TFlags, boolean>>;
